(function () {
  'use strict';
  const quantities = [1, 3, 6];
  const discounts = {once: [0, 5, 10], subscription: [20, 25, 30]};

  function pricePack(baseCents, quantity, mode) {
    const index = quantities.indexOf(quantity);
    if (!Number.isSafeInteger(baseCents) || baseCents <= 0 || index < 0 ||
        !Object.prototype.hasOwnProperty.call(discounts, mode) ||
        !Number.isSafeInteger(baseCents * quantity * 100 + 50)) {
      throw new RangeError('Use a positive price in cents, a 1/3/6 pack, and a valid purchase type.');
    }
    const regular = baseCents * quantity;
    const percent = discounts[mode][index];
    // Recharge stores subscription prices per unit. Match its rounding on every renewal.
    const product = mode === 'subscription'
      ? Math.floor((baseCents * (100 - percent) + 50) / 100) * quantity
      : Math.floor((regular * (100 - percent) + 50) / 100);
    const shipping = mode === 'once' ? 997 : 0;
    return {quantity, percent, regular, product, shipping, total: product + shipping};
  }

  function cartItemFor(catalog, quantity, mode, expectedCents) {
    if (!quantities.includes(quantity) || !Object.hasOwn(discounts, mode)) throw new Error('Choose a valid pack.');
    if (!catalog?.available) throw new Error('This product is out of stock.');
    if (!Number.isSafeInteger(catalog.variantId) || catalog.variantId < 1) throw new Error('This product is not available.');
    const item = {id: catalog.variantId, quantity};
    if (mode === 'subscription') {
      const plan = catalog.plans.find(p => p.quantity === quantity && p.months === quantity &&
        /^\d+ (bottle|bundle)s? every (month|\d+ months)$/.test(p.name));
      if (!plan || !Number.isSafeInteger(plan.id)) throw new Error('This subscription is not available yet.');
      if (plan.price * quantity !== expectedCents) throw new Error('The subscription price has changed. Reload this page before adding it.');
      item.selling_plan = plan.id;
    }
    item.properties = {_ap_offer: `${mode}_${quantity}`, _ap_pack: String(quantity), _ap_pricing: 'option_a'};
    return item;
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {pricePack, cartItemFor};
  if (typeof document === 'undefined') return;
  const root = document.querySelector('[data-pack-preview]');
  if (!root) return;
  const baseCents = Number(root.dataset.baseCents);
  const unit = root.dataset.unit;
  const bottlesPerUnit = Number(root.dataset.bottlesPerUnit);
  const intervalCount = Number(root.dataset.intervalCount);
  const intervalUnit = root.dataset.intervalUnit;
  const intervalFor = quantity => {
    const count = quantity * intervalCount;
    return count === 1 ? intervalUnit : `${count} ${intervalUnit}s`;
  };
  const subscribe = root.querySelector('[data-pack-subscribe]');
  const catalog = JSON.parse(root.querySelector('[data-pack-catalog]').textContent);
  const errorBox = root.querySelector('[data-pack-error]');
  const mainButton = root.querySelector('[data-pack-open]');
  const sticky = root.querySelector('[data-pack-sticky]');
  const money = cents => new Intl.NumberFormat('en-US', {style: 'currency', currency: 'USD'}).format(cents / 100);
  const put = (selector, value) => root.querySelectorAll(selector).forEach(node => { node.textContent = value; });

  function update() {
    const quantity = Number(root.querySelector('[name="preview-pack"]:checked').value);
    const mode = subscribe.checked ? 'subscription' : 'once';
    const selected = pricePack(baseCents, quantity, mode);
    const sub = pricePack(baseCents, quantity, 'subscription');
    root.classList.toggle('is-subscription', subscribe.checked);
    quantities.forEach(qty => {
      const card = root.querySelector(`[data-pack-card="${qty}"]`);
      const price = pricePack(baseCents, qty, mode);
      card.classList.toggle('is-selected', qty === quantity);
      card.querySelector('[data-pack-badge]').textContent = price.percent ? `Save ${price.percent}%` : 'Regular price';
      card.querySelector('[data-pack-price]').textContent = money(Math.round(price.product / (qty * bottlesPerUnit)));
      const cardTotal = card.querySelector('[data-pack-card-total]');
      if (cardTotal) cardTotal.textContent = money(price.product);
      card.querySelector('[data-pack-duration]').textContent = `${qty} month supply`;
      card.querySelector('[data-pack-card-shipping]').textContent = subscribe.checked ? 'Free shipping' : '+ $9.97 shipping';
    });
    const bottles = `${quantity} ${unit}${quantity === 1 ? '' : 's'}${bottlesPerUnit > 1 ? ` (${quantity * bottlesPerUnit} bottles)` : ''}`;
    const interval = intervalFor(quantity);
    const schedule = subscribe.checked
      ? `${bottles} delivered every ${interval}. ${money(selected.product)} charged every ${interval}. Cancel anytime.`
      : `${bottles} delivered once. One payment. No subscription.`;
    put('[data-pack-sub-saving]', `${sub.percent}%`);
    put('[data-pack-total]', money(selected.total));
    put('[data-pack-product-total]', money(selected.product));
    put('[data-pack-shipping]', selected.shipping ? money(selected.shipping) : 'Free');
    put('[data-pack-schedule]', schedule);
    put('[data-pack-selection]', `${bottles} · ${subscribe.checked ? 'Subscription' : 'One-time purchase'}`);
    put('[data-pack-sticky-description]', `${bottles} · ${subscribe.checked ? `Every ${interval}` : 'One-time purchase'}`);
    put('[data-pack-sticky-price]', money(Math.round(selected.product / (quantity * bottlesPerUnit))));
    put('[data-pack-button-text]', subscribe.checked ? 'START NOW' : 'ADD TO CART');
    put('[data-pack-billing]', subscribe.checked
      ? `Billed ${money(selected.product)} every ${interval}. Cancel anytime.`
      : `Billed ${money(selected.total)} once, including $9.97 shipping. No subscription.`);
    root.querySelector('[data-pack-controls]').disabled = false;
    root.dataset.ready = 'true';
  }
  root.addEventListener('change', update);
  root.querySelector('.ap-pack-subscription').addEventListener('click', event => {
    // Native labels already toggle the checkbox; leave their activation to the browser.
    if (event.target.closest('input, label, a, button, select, textarea')) return;
    subscribe.focus({preventScroll: true});
    subscribe.click();
  });
  let adding = false;
  [mainButton, root.querySelector('[data-pack-sticky-open]')].forEach(button => {
    button.addEventListener('click', async () => {
      if (adding) return;
      const quantity = Number(root.querySelector('[name="preview-pack"]:checked').value);
      const mode = subscribe.checked ? 'subscription' : 'once';
      const price = pricePack(baseCents, quantity, mode);
      errorBox.hidden = true;
      const buttons = [mainButton, root.querySelector('[data-pack-sticky-open]')];
      try {
        if (catalog.regularCents !== baseCents) throw new Error('These new offers are not available yet.');
        const item = cartItemFor(catalog, quantity, mode, price.product);
        if (!window.apCart) throw new Error('The cart is still loading. Please try again.');
        adding = true;
        buttons.forEach(b => { b.disabled = true; b.setAttribute('aria-busy', 'true'); });
        await window.apCart.add([item], errorBox, button);
      } catch (error) {
        errorBox.textContent = error.message;
        errorBox.hidden = false;
      } finally {
        adding = false;
        buttons.forEach(b => { b.disabled = false; b.removeAttribute('aria-busy'); });
      }
    });
  });
  root.querySelectorAll('[data-pack-sticky-change]').forEach(link => link.addEventListener('click', event => {
    event.preventDefault();
    root.scrollIntoView({block: 'start', behavior: 'instant'});
    root.querySelector('[name="preview-pack"]:checked').focus({preventScroll: true});
  }));
  let stickyFrame;
  function updateSticky() {
    stickyFrame = null;
    const viewTop = window.visualViewport?.offsetTop || 0;
    const viewBottom = viewTop + (window.visualViewport?.height || innerHeight);
    const toolbarHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ap-preview-bar')) || 0;
    const cta = mainButton.getBoundingClientRect();
    const title = document.querySelector('.product-identity h1');
    const mainVisible = cta.top >= viewTop && cta.bottom <= viewBottom - toolbarHeight;
    const pastTitle = !title || title.getBoundingClientRect().bottom < viewTop;
    const pastPurchase = root.getBoundingClientRect().bottom < viewTop;
    sticky.hidden = !!document.querySelector('dialog[open]') ||
      (matchMedia('(max-width: 899px)').matches ? !pastPurchase : !pastTitle || mainVisible);
    document.body.classList.toggle('has-sticky-purchase', !sticky.hidden);
  }
  const scheduleSticky = () => { if (stickyFrame == null) stickyFrame = requestAnimationFrame(updateSticky); };
  window.addEventListener('scroll', scheduleSticky, {passive: true});
  window.addEventListener('resize', scheduleSticky);
  window.visualViewport?.addEventListener('resize', scheduleSticky);
  window.visualViewport?.addEventListener('scroll', scheduleSticky, {passive: true});
  new ResizeObserver(scheduleSticky).observe(root);
  document.querySelectorAll('dialog').forEach(modal => new MutationObserver(scheduleSticky).observe(modal, {attributes: true, attributeFilter: ['open']}));
  update();
  updateSticky();
}());
